import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { OrgUsageSummary, OrgUsageSummaryDto, orgUsageSummaryFromDto } from '@nx-frontend/shared/types';

interface GetOrgUsageParams {
  host: string;
  userId: number;
  orgId: string;
}

export const getOrgUsageSummary = async ({ host, userId, orgId }: GetOrgUsageParams): Promise<OrgUsageSummary> => {
  const response = await axiosClient.get<OrgUsageSummaryDto>(
    `${assertServiceHost(host)}/v1/orgs/${encodeURIComponent(orgId)}/usage`,
    { userId }
  );
  return orgUsageSummaryFromDto(response.data);
};
